import React from 'react'
import OpenDey from '../components/OpenDay'
import Footer from '../components/footer'
export default function OpenDay() {
  return (
    <div className='h-screen'>
      
      <OpenDey/>
      <Footer />
    </div>
  )
}
